import Model from './model'

export default class Signin extends Model {
  constructor() {
    super()
    this.hydrate({
      user_id: '',
    })
  }
}